import React, { Component } from 'react';
import classNames from 'classnames';

import { injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import { ensureListing } from '../../../util/data';
import { isIdentityVerified } from '../../../util/diditVerification';

import css from './SearchMapPriceLabel.module.css';

// The first name of the sitter: "Dana & Luis P." -> "Dana"
const firstName = displayName =>
  typeof displayName === 'string' ? displayName.split(/[\s&,]+/).filter(Boolean)[0] : null;

// A small image of the sitter's profile photo, if there is one
const avatarUrl = author => {
  const variants = author?.profileImage?.attributes?.variants || {};
  const variant =
    variants['scaled-small'] || variants['listing-card'] || Object.values(variants)[0];
  return variant?.url || null;
};

/**
 * SearchMapPriceLabel component — the sitter's pin on the map (02_Search_Mobile/SPEC.md):
 * a round photo, the first name and an arrow. Verified sitters are olive, the active one is ink.
 * The name is kept from the template; the label shows no price.
 * TODO: change to functional component
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {propTypes.listing} props.listing
 * @param {Function} props.onListingClicked
 * @param {intlShape} props.intl
 * @returns {JSX.Element}
 */
class SearchMapPriceLabel extends Component {
  shouldComponentUpdate(nextProps) {
    const currentListing = ensureListing(this.props.listing);
    const nextListing = ensureListing(nextProps.listing);
    const isSameListing = currentListing.id.uuid === nextListing.id.uuid;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;
    const hasSameRadiusStatus = this.props.isOutsideRadius === nextProps.isOutsideRadius;

    return !(isSameListing && hasSameActiveStatus && hasSameRefreshToken && hasSameRadiusStatus);
  }

  render() {
    const {
      className,
      rootClassName,
      listing,
      onListingClicked,
      isActive,
      isOutsideRadius,
    } = this.props;
    const currentListing = ensureListing(listing);
    const author = currentListing.author;

    const name =
      firstName(author?.attributes?.profile?.displayName) || currentListing.attributes.title;
    const photo = avatarUrl(author);
    const isVerified = isIdentityVerified(author);

    const classes = classNames(rootClassName || css.root, className, {
      [css.outsideRadius]: isOutsideRadius,
    });
    const labelClasses = classNames(css.pin, {
      [css.pinVerified]: isVerified,
      [css.pinActive]: isActive,
    });

    return (
      <button
        className={classes}
        onClick={() => onListingClicked(currentListing)}
        aria-label={name}
        disabled={isOutsideRadius}
      >
        <span className={labelClasses}>
          <span className={css.avatar}>
            {photo ? <img className={css.avatarImage} src={photo} alt="" /> : null}
          </span>
          {isVerified ? (
            <span className={css.check} aria-hidden="true">
              ✓
            </span>
          ) : null}
          <span className={css.name}>{name}</span>
          <span className={css.arrow} aria-hidden="true">
            →
          </span>
          <span className={css.pointer} aria-hidden="true" />
        </span>
      </button>
    );
  }
}

export default injectIntl(SearchMapPriceLabel);
